import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor(private data: DataService, private router: Router) { }

  ngOnInit(): void {
    this.data.logout();
    this.router.navigate(['/']);

  }

}
